import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@dls/react-core';
import { createDevice, Devices, Subject } from '../../api/studykit';
import { StyledBlueHeading } from '../styled/styles';
import { StudyPageContext } from '../../App';
import { useSnackbar } from 'notistack';
import { KeyedMutator } from 'swr/dist/types';
import { NotiStackAction } from '../styled/notistack-action';
import { DeviceForm } from '../devices/device-form';
import { AsyncSubmitHandler } from '../../helpers/form-error-handling';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  subject: Subject;
  mutate: KeyedMutator<any>;
}

export const CreateSubjectDeviceDialog: React.FC<DialogProps> = ({
  onClose,
  open,
  subject,
  mutate,
}) => {
  const { study } = useContext(StudyPageContext);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit: AsyncSubmitHandler<Devices> = async (data, event) => {
    await createDevice(study.id, subject.id, data);
    await mutate();
    enqueueSnackbar(`${data.name} has been added for ${subject.name}`, {
      variant: 'success',
      action: <NotiStackAction close={closeSnackbar} />,
    });
    onClose();
    event?.preventDefault();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle disableTypography>
        <StyledBlueHeading variant={'h3'}>Assign a new device</StyledBlueHeading>
      </DialogTitle>
      <DialogContent>
        <DeviceForm onSubmit={onSubmit} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
};
